export default __webpack_public_path__ + "static/logo-blue-48a8bf08ac7b90006899288f6215b74f.png";